import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';
import {
  FULL_SCREEN_PLAYER,
  EXIT_FULL_SCREEN_PLAYER,
  SET_HERO_INDEX,
} from 'actions/hero';

const INITIAL_STATE = Immutable({
  fullScreenPlayer: false,
  videoId: null,
  setIndex: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case FULL_SCREEN_PLAYER:
      return state.merge({
        fullScreenPlayer: true,
        videoId: action.payload,
      });
    case EXIT_FULL_SCREEN_PLAYER:
      return state.merge({ fullScreenPlayer: false });
    case SET_HERO_INDEX:
      return state.merge({ setIndex: action.payload });
    default:
      return state;
  }
};
